export abstract class ShowInactiveService {
  public showInactive = false;
}
